<template>
    <div>
        <div class="pl-[20px]">
            <div @click="$router.go(-1)" class="flex text-[#BD9135] items-center ml-3 mt-2 cursor-pointer">
                <svg width="10" height="19" viewBox="0 0 10 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8 17L1.56957 10.8258C0.810144 10.0966 0.810144 8.90341 1.56957 8.17424L8 2" stroke="#BD9135" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="square" stroke-linejoin="round"/>
                </svg>
                <div class="ml-2 text-[#BD9135]">
                    Назад
                </div>
            </div>
        </div>

        <div class="text-white text-[24px] font-bold text-center">Опитування гравця {{ surveyObject?.student_name }} {{ surveyObject?.student_surname }}</div>

        <div class="w-[90%] mx-auto mt-[20px] mb-[20px]">
            <div v-for="step in surveyObject?.steps" class="rounded-lg p-4 m-4">
                <div class="font-bold text-[21px] text-[#BD9135]">{{ step.title }}</div>
                <div class="mt-[10px] text-[19px]">{{ step.answer }}</div>
            </div>
        </div>
    </div>
</template>
<script>
import { getAllStudentsListInGroup, getAllSurveysByTrainingId, getSurveyByStudentId } from '@/services/apiRequests'
import { ref, onMounted } from 'vue'
import { useRoute } from 'vue-router';

export default {
    name: "AfterMatchSurveyStudent",
    setup() {
        const route = useRoute();
        const surveyObject = ref(null);

        const studentId = route.params.student_id;
        const trainingId = route.params.training_id;

        onMounted(async () => {
            surveyObject.value = (await getSurveyByStudentId(studentId, trainingId)).survey;

            console.log('surveyObject.value', surveyObject.value);
        })

        return {
            surveyObject
        }
    }
}
</script>
<style lang="scss"></style>